module.exports = __webpack_public_path__ + "static/media/photo.6205e0e1.svg";